import { IsDevEnv } from '@/app'

export const createGlobalTimeout = (name: string) => {
  const map = new Map()

  const clear = () => {
    if (map.get(name)) {
      clearTimeout(map.get(name))
      map.set(name, null)
    }
  }

  return {
    get timeout() {
      return map.get(name)
    },
    set(callback: () => void, ms: number) {
      clear()

      return map.set(
        name,
        setTimeout(() => {
          callback()
          clear()
        }, ms)
      )
    },
    clear
  }
}

export function clamp(min: number, value: number, max: number): number {
  if (!value) return min
  return Math.min(Math.max(value, min), max)
}

export function createLog(prefix: string, enabled = true) {
  return (...args: unknown[]) => {
    if (IsDevEnv && enabled) {
      console.log(`[${prefix}]`, ...args)
    }
  }
}
